export default "__VITE_ASSET__CQb4klJ6__"